import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface StageLoaderProps {
    className?: string
}

const StageLoader: FC<StageLoaderProps> = ({ className }): ReactNode => {
    return (
        <div
            role='status'
            className={cn('absolute inset-0 flex flex-col items-center justify-center gap-5', className)}
        >
            <span className='relative flex size-16 items-center justify-center'>
                <span className='absolute inset-0 rounded-full border border-primary/25' />
                <span className='absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-primary [animation-duration:1.4s]' />
                <span className='size-2 rounded-full bg-primary shadow-[0_0_24px_6px_oklch(0.8_0.12_80/0.4)]' />
            </span>

            <span className='font-heading text-lg tracking-wide text-foreground/80'>
                מרימים את המסך
            </span>
        </div>
    )
}

export default StageLoader
